<template>
  <v-container fluid class="av-page">
    <!-- LISTAGEM DE DISPOSITIVOS -->
    <template v-if="!addQuest">
      <div class="av-card av-filtro-card" v-if="user.tipo == 'ADMIN'">
        <span class="av-section-label">Empresa</span>
        <v-row dense>
          <v-col cols="12" sm="8" md="6">
            <v-autocomplete
              outlined
              dense
              hide-details
              v-model="empresaSelecionada"
              :items="empresas"
              item-text="nome"
              item-value="id"
              placeholder="Selecione a empresa"
              no-data-text="Nenhuma empresa encontrada"
              @input="carregaDispositivos(empresaSelecionada)"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>

      <div class="av-card av-panel">
        <div class="av-toolbar">
          <v-text-field
            v-model="tabela.busca"
            append-icon="search"
            label="Procurar"
            outlined
            dense
            hide-details
            single-line
            class="av-busca"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            v-if="user.tipo == 'ADMIN'"
            depressed
            color="primary"
            @click="dialogoDispositivo = true"
            :disabled="empresaSelecionada == ''"
          >
            <v-icon left>add</v-icon>Novo dispositivo
          </v-btn>
        </div>

        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          :loading="tabela.carregamento"
          loading-text="Buscando dispositivos..."
          sort-by="descricao"
          class="av-table"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:[`item.ativo`]="{ item }">
            <v-chip small label :color="item.ativo ? 'success' : 'error'" text-color="white">
              {{ item.ativo ? 'Ativo' : 'Inativo' }}
            </v-chip>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="editItem(item)">
                  <v-icon small color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span v-if="user.tipo == 'ADMIN'">Editar</span>
              <span v-else>Associar Pesquisa</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="deleteItem(item)">
                  <v-icon small color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-alert v-if="empresaSelecionada == ''" dense text outlined type="info" class="my-4">
              Selecione uma empresa para visualizar os dispositivos
            </v-alert>
            <v-alert v-else dense text outlined type="warning" class="my-4">
              Nenhum dispositivo cadastrado
            </v-alert>
          </template>
        </v-data-table>
      </div>
    </template>

    <!-- ASSOCIAR PESQUISA (STEPPER) -->
    <div v-if="addQuest" class="av-card av-panel">
      <v-stepper v-model="e1" flat class="av-stepper">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Associar Pesquisa</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <div class="av-step-body">
              <v-row class="av-form-row">
                <v-col cols="12" md="6">
                  <label class="av-field-label">Descrição</label>
                  <v-text-field disabled outlined dense hide-details v-model="dispositivo.descricao"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <label class="av-field-label">Pesquisa</label>
                  <v-select
                    outlined
                    dense
                    hide-details
                    v-model="dispositivo.questionarioId"
                    :items="questionarios"
                    item-text="titulo"
                    item-value="id"
                    placeholder="Selecione a pesquisa"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <div class="av-step-actions">
              <v-spacer></v-spacer>
              <v-btn text @click="addQuest=false">Cancelar</v-btn>
              <v-btn depressed color="primary" @click="editarDispositivo()">Salvar</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <!-- DIÁLOGO CADASTRO/EDIÇÃO -->
    <v-dialog v-model="dialogoDispositivo" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">{{ formTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row class="av-form-row">
            <v-col cols="12">
              <label class="av-field-label">Descrição <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="dispositivo.descricao"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="av-field-label">Endereço MAC <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-mask="'NN:NN:NN:NN:NN:NN'" v-model="dispositivo.mac"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="av-field-label">&nbsp;</label>
              <div class="av-switch-field">
                <v-checkbox
                  v-model="dispositivo.ativo"
                  :label="dispositivo.ativo ? 'Ativo' : 'Inativo'"
                  dense
                  hide-details
                  class="av-check ma-0 pa-0"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col cols="12">
              <label class="av-field-label">Pesquisa</label>
              <v-select
                outlined
                dense
                hide-details
                v-model="dispositivo.questionarioId"
                :items="questionarios"
                item-text="titulo"
                item-value="id"
                placeholder="Selecione a pesquisa"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoDispositivo = false">Fechar</v-btn>
          <v-btn depressed color="primary" @click="criarDispositivo" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn depressed color="primary" @click="editarDispositivo" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({
      e1: 1,
      addQuest: false,
      dialogoDispositivo: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Descrição', align: 'start', value: 'descricao', },
          { text: 'MAC', align: 'start', value: 'mac', },
          { text: 'Pesquisa', value: 'questionario.titulo' },
          { text: 'Status', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: []
      },
      questionarios: [],
      idDispositivo: '',
      editedIndex: -1,
      dispositivo: {
        descricao: '',
        ativo: true,
        mac: '',
        questionarioId: '',
        empresaId: '',
      },
      defaultDisp: {
        descricao: '',
        ativo: true,
        mac: '',
        questionarioId: '',
        empresaId: '',
      },
      empresas: [],
      empresaSelecionada: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo dispositivo' : 'Editar dispositivo'
      } 
    }),

    watch: {
      dialogoDispositivo(val) {
        if (val == false) {
          setTimeout(() => {
            this.dispositivo = Object.assign({}, this.defaultDisp)
            this.editedIndex = -1
          }, 300);
        }
      }
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaDispositivos(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaDispositivos (id) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        await axios.get(baseApiUrl + 'Dispositivos?filter={"where":{"empresaId":"' + id + '"}, "include":"questionario"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
        })

        await axios.get(baseApiUrl + 'Questionarios?filter={"where":{"empresaId":"' + id + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.questionarios = response.data
          }
        })
      },

      editItem (item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.idDispositivo = item.id
        this.dispositivo = Object.assign({}, item)
        this.dialogoDispositivo = true
      },

      async criarDispositivo() {
        var vm = this;
        if (!this.dispositivo.descricao || !this.dispositivo.mac) {
          vm.$refs.chamaSnackbar.snack("warning","Informe o nome e MAC do dispositivo","white")
        } else {
          this.dispositivo.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.user.empresaId
          await axios.post(baseApiUrl + 'Dispositivos/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.dispositivo)
          .then(response => {
            if (response.data) {
              this.carregaDispositivos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              this.dialogoDispositivo = false
              vm.$refs.chamaSnackbar.snack("success","Operação realizada com sucesso!","white")
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FEC8C8","Erro ao realizar operação","#BF4554")
          })
        }
      },

      async editarDispositivo() {
        var vm = this
        if (!this.dispositivo.descricao || !this.dispositivo.mac) {
          vm.$refs.chamaSnackbar.snack("warning","Informe o nome e MAC do dispositivo","white")
        } else {
          await axios.patch(baseApiUrl + 'Dispositivos/' + this.idDispositivo + '?access_token=' + sessionStorage.getItem('accToken'), this.dispositivo)
          .then(response => {
            if (response.data) {
              this.carregaDispositivos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              this.dialogoDispositivo = false
              vm.$refs.chamaSnackbar.snack("success","Operação realizada com sucesso!","white")
            }           	
          })
          .catch(() => {
            var vm = this;          
            vm.$refs.chamaSnackbar.snack("#FEC8C8","Erro ao realizar operação","#BF4554")
          })
        }
      },

      async deleteItem (item) {
        var vm = this
        var r = confirm('Deseja realmente excluir o dispositivo ' + item.descricao + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Dispositivos/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            vm.$refs.chamaSnackbar.snack("success","Operação realizada com sucesso!","white")
            this.carregaDispositivos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)                              
          })
        }
      },
    },
  }
</script>

<!-- Estilos globais legados (mantidos para telas ainda não migradas) -->
<style>
  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-filtro-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin-bottom: 8px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-field-label .req {
    color: #c62828;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  /* Booleano com aparência de campo (igual a Empresas/Usuários) */
  .av-switch-field {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.38);
    padding: 6px 12px;
    min-height: 40px;
  }

  ::v-deep .av-check .v-input__slot {
    margin: 0;
  }

  ::v-deep .av-check .v-input__control {
    min-height: auto;
  }

  ::v-deep .av-check .v-label {
    color: rgba(0, 0, 0, 0.7);
  }

  /* Respiro confortável entre os campos do formulário */
  ::v-deep .av-form-row > [class*="col"] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  /* Stepper sem moldura, integrado ao cartão */
  ::v-deep .av-stepper.v-stepper {
    box-shadow: none;
  }

  ::v-deep .av-stepper .v-stepper__content {
    padding: 16px 4px 0;
  }

  .av-step-body {
    min-height: 120px;
    padding-bottom: 8px;
  }

  .av-step-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--av-border);
    padding-top: 12px;
    margin-top: 8px;
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>